import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  transform(rawPhoneNumber: string) {
    let phoneNumberString = `${rawPhoneNumber}`;
    phoneNumberString = phoneNumberString.replace(/\D/g, '');

    if (phoneNumberString.length === 10) {
      // reformat and return phone number
      return phoneNumberString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return rawPhoneNumber;
  }
}
